import { useEffect, useState } from 'react';
import TwoFactorPromptContainer from './TwoFactorPromptContainer';
import UIModal from 'UIComponents/dialog/UIModal';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { View } from 'foundations-components/components/View';
import { usageTracker } from '../utils/usageTracker.ts';
import { useReAuth } from '../hooks/useReAuth';
import VerificationOptions from '../components/VerificationOptions';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function WithReAuth(props) {
  const [isOpen, setOpen] = useState(false);
  const {
    hasPasskeys,
    initializeReAuth,
    hasSecondaryMethod,
    obfuscatedInfo,
    authMethod
  } = useReAuth();
  const openOnClick = typeof props.openOnClick === 'undefined' ? true : props.openOnClick;
  useEffect(() => {
    if (props.openByDefaultForTesting) {
      onClickHandler();
    }
  });
  const reAuthObject = {
    onSuccess: () => {
      props.onSuccess(...(props.argArray !== undefined ? props.argArray : []));
    },
    openModal: openModalOnClick,
    skipVerificationIfNotSet: !!props.skipVerificationIfNotSet,
    email: props.email
  };
  function onClickHandler() {
    initializeReAuth(reAuthObject);
  }
  function openModalOnClick() {
    usageTracker.track('reauthProcess', {
      step: 'opened'
    });
    if (openOnClick) setOpen(true);
  }
  function successTracker(success) {
    return (...args) => {
      usageTracker.track('reauthProcess', {
        step: 'authenticated'
      });
      if (success) success(...args);
    };
  }
  function onClose() {
    setOpen(false);
  }
  return props.isDisabled ? /*#__PURE__*/_jsx(_Fragment, {
    children: props.children
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [isOpen ? /*#__PURE__*/_jsxs(UIModal, {
      width: 1250,
      className: "p-x-6 p-y-10",
      children: [/*#__PURE__*/_jsx(CloseButton, {
        color: "icon-primary-default",
        onClick: onClose
      }), hasPasskeys && props.email ? /*#__PURE__*/_jsx(VerificationOptions, Object.assign({}, props, {
        onSuccess: successTracker(props.onSuccess),
        onClose: onClose,
        reAuthObject: reAuthObject,
        email: props.email
      })) : /*#__PURE__*/_jsx(TwoFactorPromptContainer, Object.assign({}, props, {
        onSuccess: successTracker(props.onSuccess),
        isOpen: isOpen,
        onClose: onClose,
        authMethod: authMethod,
        obfuscatedInfo: obfuscatedInfo,
        hasSecondaryMethod: hasSecondaryMethod
      }))]
    }) : null, /*#__PURE__*/_jsx(View, {
      inlineSize: "fit-content",
      onClick: onClickHandler,
      children: props.children
    })]
  });
}